import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useState } from 'react';
import { palette } from '../../assets/theme/theme';


export function BackArrow({ onClick } : any) {

    const [baseColor, setBaseColor] = useState(palette.rodrimaq_red);




    return (
        <div style={{
            display: 'flex',
            width: 50,
            height: 50,
            marginBottom: 0,
            alignItems: 'center',
            justifyContent: 'center',
            color: palette.rodrimaq_red,
            marginLeft: 30,
            marginTop: 10,
            // backgroundColor: baseColor,
            cursor: 'pointer',
        }}
        // onMouseEnter={()=> setBaseColor('white')}
        // onMouseLeave={()=>setBaseColor(palette.rodrimaq_red)}
        onClick={onClick}
        >
            <ArrowBackIosNewIcon style={{color: palette.rodrimaq_red }}  />
            <span>Voltar</span>
        </div>

    )

}